export interface CollisionBalanceConfig {
  offensiveWeightFactor: number;
  defensiveWeightFactor: number;
  pushPowerPerLevel: number;
  impulseScale: number;
  minCollisionImpulse: number;
  maxCollisionImpulse: number;
  impactDeadZone: number;
  minimumApproachSpeed: number;
  collisionCooldownMs: number;
  separationDistance: number;
  winnerRecoilFactor: number;
  balancedBounceFactor: number;
  knockbackImmunityMs: number;
  strongImpactThreshold: number;
  maxKnockbackSpeed: number;
  velocityDamping: number;
  stopSpeed: number;
  airborneControlFactor: number;
  controlRecoveryFactor: number;
  recoveryDurationMs: number;
  baseAcceleration: number;
  controlAccelerationFactor: number;
  weightAccelerationPenalty: number;
  speedPerLevel: number;
  weightSpeedPenalty: number;
}

export const COLLISION_BALANCE: Readonly<CollisionBalanceConfig> = {
  offensiveWeightFactor: 0.25,
  defensiveWeightFactor: 0.65,
  pushPowerPerLevel: 0.2,
  impulseScale: 1.15,
  minCollisionImpulse: 0.06,
  maxCollisionImpulse: 0.75,
  impactDeadZone: 0.015,
  minimumApproachSpeed: 0.025,
  collisionCooldownMs: 220,
  separationDistance: 0.002,
  winnerRecoilFactor: 0.18,
  balancedBounceFactor: 0.55,
  knockbackImmunityMs: 190,
  strongImpactThreshold: 0.2,
  maxKnockbackSpeed: 1.1,
  velocityDamping: 0.92,
  stopSpeed: 0.001,
  airborneControlFactor: 0.16,
  controlRecoveryFactor: 0.035,
  recoveryDurationMs: 420,
  baseAcceleration: 0.22,
  controlAccelerationFactor: 0.12,
  weightAccelerationPenalty: 0.08,
  speedPerLevel: 0.15,
  weightSpeedPenalty: 0.07,
};